/*
 * Triple Y — רענון העגלה בחזרה עם כפתור "אחורה"
 * =============================================
 * נבנה 31.08.2026 אחרי דיווח לקוח אמיתי.
 *
 * הבאג: לקוח הוסיף מוצר לעגלה, לחץ "אחורה" בדפדפן, וראה עגלה ריקה.
 * המוצר היה בעגלה כל הזמן — רק התצוגה שיקרה. כשנכנס למוצר, העגלה "חזרה".
 *
 * ── שרשרת הסיבות, כפי שנמדדה בדפדפן ──────────────────────────────────
 * ① בחזרה אחורה הדפדפן מגיש את הדף מתגובת HTTP שמורה. `navigation.type`
 *    הוא `back_forward`, וה-HTML הוא זה שרונדר **לפני** ההוספה.
 * ② בועית המונה (`cart-icon-bubble`) מרונדרת בשרת, ולכן היא חלק מאותו
 *    HTML ישן ומראה עגלה ריקה.
 * ③ מגירת העגלה גרועה יותר: היא יושבת בתוך `<template class="deferred">`
 *    ומתמלאת רק בלחיצה, דרך `init()`. התבנית עצמה מגיעה מה-HTML הישן,
 *    ולכן הלחיצה מגישה ללקוח "העגלה שלך ריקה" מתוך תוכן ישן.
 * ④ בתמה אין שום מאזין ל-`pageshow`, ולכן אף אחד לא מסנכרן מחדש.
 *
 * 🔴 לא ייחודי לקטגוריה אחת. נמדד 31.08.2026 גם בקטגוריית אילת, גם
 *    בקטגוריית המרכז וגם בדף הבית — בכל הדפים אותו כשל.
 *
 * ── למה דווקא init() ואז reload() ────────────────────────────────────
 * 🔴 אסור לקרוא ל-`reload()` לבד. היא נשענת על `renderContents`, וזו
 *    ניגשת ל-`.drawer__inner` בשורה הראשונה שלה. בדף קטגוריה המגירה עוד
 *    לא אותחלה, ‏`.drawer__inner` אינו קיים, והקריאה זורקת
 *    `TypeError: Cannot read properties of null (reading 'classList')`.
 *    **הגרסה הראשונה של הקובץ הזה נפלה בדיוק שם, ולא עשתה כלום.**
 *    נתפס 31.08.2026 בתמת בדיקות, לפני שהגיע לחי.
 *
 * ‏`init()` בונה את `.drawer__inner` מהתבנית (הישנה, וזה בסדר — המגירה
 * סגורה ואיש לא רואה אותה), ומיד אחריה `reload()` מושכת סקשנים טריים
 * ודורסת את התוכן. ‏`reload()` כבר מעבירה `preventOpen = true`, ולכן
 * המגירה לא נפתחת מעצמה, ומעדכנת גם את הבועית — שתיהן ב-getSectionsToRender.
 *
 * אימות: qa/tripley-tests/scripts/_verify_cart_back_fix.mjs
 */
(function () {
  'use strict';

  /* `event.persisted` נכון ל-bfcache מלא. אבל הדף הזה חוזר לרוב מתגובת HTTP
   * שמורה, ואז `persisted` הוא false ורק `navigation.type` מסגיר את זה.
   * צריך את שניהם, אחרת חצי מהמקרים לא נתפסים. */
  function cameFromHistory(event) {
    if (event && event.persisted) return true;
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return !!nav && nav.type === 'back_forward';
    } catch (e) {
      return false;
    }
  }

  function sectionInnerHTML(html, selector) {
    try {
      var clean = String(html).replace(/<template\b[^>]*>|<\/template>/g, '');
      var found = new DOMParser().parseFromString(clean, 'text/html').querySelector(selector);
      return found ? found.innerHTML : null;
    } catch (e) {
      return null;
    }
  }

  /* דף בלי מגירה, כמו /cart. לפחות הבועית חייבת להיות נכונה. */
  function refreshBubbleOnly() {
    var bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-icon-bubble', { cache: 'no-store' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-icon-bubble']) return;
        var html = sectionInnerHTML(sections['cart-icon-bubble'], '.shopify-section');
        if (html !== null) bubble.innerHTML = html;
      })
      .catch(function () {
        /* שקט בכוונה. כשל ברשת משאיר את הדף כמו שהיה לפני התיקון — לא
         * מחמיר, ולא מקפיץ שגיאה ללקוח. */
      });
  }

  var done = false;

  function refreshCart() {
    if (done) return;
    done = true;
    /* ty-cart-back-reload >>> */
    /* pri-07, 14.10.2026: בדף העגלה המגירה אינה רלוונטית, ואתחולה מכפיל את cart.js ושובר את הפח.
       הדף עצמו ישן (חזר מהמטמון), ולכן טוענים אותו מחדש. */
    if (document.body && document.body.classList.contains('cart-template')) { location.reload(); return; }
    /* <<< ty-cart-back-reload */

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.init !== 'function' || typeof drawer.renderContents !== 'function') {
      refreshBubbleOnly();
      return;
    }

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-icon-bubble,cart-drawer', { cache: 'no-store' })
      .then(function (res) {
        if (!res.ok) throw new Error('sections ' + res.status);
        return res.json();
      })
      .then(function (sections) {
        if (!sections['cart-drawer']) throw new Error('no cart-drawer section');

        drawer.init();                                  // בונה .drawer__inner מהתבנית הישנה
        drawer.renderContents({ sections: sections }, true); // דורס אותה בתוכן טרי

        /* 🔴 `renderContents` מנקה `is-empty` מ-`.drawer__inner` בלבד, ולא
         * מהאלמנט `<cart-drawer>` עצמו. המחלקה על האלמנט החיצוני מסתירה
         * ב-CSS את `.drawer__header`, את `.drawer__shipping-bar` ואת
         * ההמלצות (assets/component-cart-drawer.css שורות 52-55).
         * בלי השורה הזאת המגירה נפתחת עם שורת המוצר ב-DOM אבל עם חלל לבן
         * במקומה. נתפס 31.08.2026 בצילום מסך מתמת הבדיקות, אחרי שבדיקת
         * ה-DOM לבדה הכריזה "תקין". */
        var fresh = new DOMParser()
          .parseFromString(String(sections['cart-drawer']), 'text/html')
          .querySelector('cart-drawer');
        if (fresh) {
          drawer.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
        }
      })
      .catch(function () {
        /* נופלים חזרה לבועית בלבד. מונה נכון עם מגירה ישנה עדיף על כלום. */
        refreshBubbleOnly();
      });
  }

  window.addEventListener('pageshow', function (event) {
    if (cameFromHistory(event)) refreshCart();
  });
})();
